import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../redux/actions";
import Orders from "../elements/orders";
import { Loader } from "../elements/loader";
import { Carcontext } from "../context/carcontext";

const Orderslist = ({ status }) => {

    const dispatch = useDispatch()
    const [clientId, setClientId] = useState({})
    const orderslist = useSelector((state) => {
        return state.orders.orders
    })
    const { theme } = useContext(Carcontext)
    const loading = useSelector(state => state.app.loading)
    useEffect(() => {
        async function deriveUserId() {
            try {
                const token = await JSON.parse(localStorage.getItem(`newCreatedUserData`))
                if (JSON.stringify(token) !== '{}') {
                    setClientId(token.newUserId)
                }
            } catch (e) { }
        }
        deriveUserId()
        if (orderslist.length > 0) {
            return
        } else {
            dispatch(fetchOrders())
        }
    }, [])

    if (loading) {
        return <Loader theme={theme} />
    }

    //create 3 columns: "в процессе", "завершено", "ожидает начала"
    //фильтр по статусу
    const statusFiltered = orderslist.filter(order => order.status === status)

    return statusFiltered.map((order, index) => <Orders order={order} clientId={clientId} key={index} />)
}

export default Orderslist
